import { render, staticRenderFns } from "./PreDepositSelectComponent.vue?vue&type=template&id=45b1c8a7&scoped=true&"
import script from "./PreDepositSelectComponent.vue?vue&type=script&lang=js&"
export * from "./PreDepositSelectComponent.vue?vue&type=script&lang=js&"
import style0 from "./PreDepositSelectComponent.vue?vue&type=style&index=0&id=45b1c8a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b1c8a7",
  null
  
)

export default component.exports